import React from 'react';
import { Container, Row, Col, Alert, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaHeart, FaShoppingBag } from 'react-icons/fa';
import ProductCard from '../components/ProductCard';
import useWishlistStore from '../store/wishlistStore';
import SEO from '../components/SEO';

const Wishlist = () => {
  const { items, clearWishlist } = useWishlistStore();

  return (
    <>
      <SEO 
        title="My Wishlist"
        description="View your saved products and favorite items at IT World."
      />
      <Container className="py-5">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h1>
            <FaHeart className="text-danger me-2" />
            My Wishlist
          </h1>
          {items.length > 0 && (
            <Button variant="outline-danger" size="sm" onClick={clearWishlist}>
              Clear Wishlist
            </Button>
          )}
        </div>

        {items.length === 0 ? (
          <Alert variant="info" className="text-center py-5">
            <FaHeart size={48} className="text-muted mb-3 d-block mx-auto" />
            <h4>Your wishlist is empty</h4>
            <p className="text-muted mb-4">
              Save products you're interested in by clicking the heart icon.
            </p>
            <Button as={Link} to="/products" variant="primary">
              <FaShoppingBag className="me-2" /> Browse Products
            </Button>
          </Alert>
        ) : (
          <>
            <p className="text-muted mb-4">{items.length} item(s) in your wishlist</p>
            <Row>
              {items.map((product) => (
                <Col key={product._id} lg={3} md={4} sm={6} className="mb-4">
                  <ProductCard product={product} />
                </Col>
              ))}
            </Row>
          </>
        )}
      </Container>
    </>
  );
};

export default Wishlist;
